var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5932 25.6258C26.1095 25.6258 27.3387 24.3966 27.3387 22.8803C27.3387 21.364 26.1095 20.1348 24.5932 20.1348C23.0769 20.1348 21.8477 21.364 21.8477 22.8803C21.8477 24.3966 23.0769 25.6258 24.5932 25.6258Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9509 6.40625H20.9331C21.904 6.40625 22.8351 6.79193 23.5216 7.47845C24.2081 8.16497 24.5938 9.09609 24.5938 10.067C24.5938 11.0379 24.2081 11.969 23.5216 12.6555C22.8351 13.342 21.904 13.7277 20.9331 13.7277H9.9509C8.7373 13.7277 7.5734 14.2098 6.71525 15.0679C5.8571 15.9261 5.375 17.09 5.375 18.3036C5.375 19.5172 5.8571 20.6811 6.71525 21.5392C7.5734 22.3974 8.7373 22.8795 9.9509 22.8795H21.8482",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.92773H6.85715",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92871 3V8.85715",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRoute);
export default __webpack_public_path__ + "static/media/addRoute.3007291c995b5b77466bf252d782c2ca.svg";
export { ForwardRef as ReactComponent };